import { Helmet } from "react-helmet-async";
import ChatInterface from "@/components/ChatInterface";

export default function HomePage() {
  return (
    <>
      <Helmet>
        <link rel="canonical" href="https://spannr.co.za/" />
      </Helmet>
      <ChatInterface />
    </>
  );
}
